import React, { useState, useEffect } from 'react';
import { Chart } from "react-google-charts";

function AccountHistoryChart(props) {
    const [chartData, setChartData] = useState([]);

    useEffect(() => {
        async function fetchData() {
            try {
                let url = `/api/accountBalanceHistory?accountId=${props.accountId}`;
                if (props.userId) {
                    url += `&userId=${props.userId}`;
                }
                const response = await fetch(url);
                const result = await response.json();

                if (result && Array.isArray(result)) {
                    let formattedData = [["Date", "Balance"]];
                    result.forEach(e => {
                        let d = new Date(e.date || e[0]);
                        let dateStr = (d.getMonth() + 1) + "/" + d.getDate() + "/" + (d.getFullYear() - 2000);
                        let balance = e.balance !== undefined ? e.balance : e[1];
                        formattedData.push([dateStr, Number(balance)]);
                    });
                    setChartData(formattedData);
                }
            } catch (err) {
                console.error(err);
            }
        }
        if (props.accountId) {
            fetchData();
        }
    }, [props.accountId, props.userId]);

    if (chartData.length <= 1) {
        return null;
    }

    return (
        <Chart
            chartType="LineChart"
            data={chartData}
            width="100%"
            height="150px"
            options={{
                chartArea: { width: '75%', height: '65%' },
                legend: { position: 'none' },
                hAxis: { title: null },
                vAxis: { title: null, format: 'short' }
            }}
        />
    );
}

export default AccountHistoryChart;
